// Utility-Funktionen für die Stoppuhr
export const formatTime = (milliseconds) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    const ds = Math.floor((milliseconds % 1000) / 100); // Zehntelsekunden
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${ds}`;
};

export const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const generateExportData = (grid, recordedTimes, rows, lanes) => {
    const exportData = [];
    
    for (let row = 0; row < rows; row++) {
        for (let lane = 0; lane < lanes; lane++) {
            const athlete = grid[row][lane];
            if (athlete) {
                const key = `${row}-${lane}`;
                const times = recordedTimes[key] || [];
                
                exportData.push({
                    Sportler: `${athlete.surname} ${athlete.lastname}`,
                    Zeiten: times.map(t => `${formatTime(t.time)}`).join('; ')
                });
            }
        }
    }
    
    return exportData;
};
